import { useParams } from 'react-router';
import React, { ReactElement, useEffect } from 'react';
import {
  Breadcrumbs,
  getTitle,
  homeBreadcrumb,
  PageLoader,
  setTitle,
} from 'slovlex-idsk-react-components';
import routes from '../../../routing/routes';
import GlobalErrors from '../../../module/GlobalErrors';
import SecuredPage from '../../../module/SecuredPage';
import Layout from '../../Layout';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import { UserRoleEnum } from '../../../model/currentuser/UserRole';
import NotifikaciaHistoriaList
  from '../../../module/LegislativnyMaterial/NotifikaciaHistoriaList/NotifikaciaHistoriaList';
import useLegislativnyMaterialDetail
  from '../../../module/LegislativnyMaterial/LegislativnyMaterialDetail/hooks/useLegislativnyMaterialDetail';
import SuccessMessages from '../../../module/SuccessMessages';
import isPredbeznaInformacia from '../../../function/isPredbeznaInformacia';

const NotifikaciaHistoriaListPage = (): ReactElement => {
  const {
    type,
    year,
    index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number, pracovnyKrokId: string }>();

  const {
    materialStatus,
    materialDetail,
  } = useLegislativnyMaterialDetail();

  useEffect(() => {
    setTitle(getTitle());
  }, [materialStatus.loading]);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          heading: isPredbeznaInformacia(type) ? 'Predbežné informácie' : 'Legislatívne procesy',
          to: isPredbeznaInformacia(type) ? routes.procesy.predbeznaInformacia.list : routes.procesy.list,
        },
        {
          to: routes.procesy.detail.withParams(type, year, index),
          heading: `${type}/${year}/${index}`,
        },
        {
          heading: 'Notifikácie k legislatívnemu procesu',
          to: routes.procesy.admin.notifikacie.withParams(type, year, index),
        },
      ]}
      />
      <GlobalErrors />
      <SecuredPage
        allowForRoles={[UserRoleEnum.SUPERADMIN]}
        requestStatus={materialStatus.responseCode}
      >
        <PageLoader loading={materialStatus.loading}>
          <>
            <SuccessMessages />
            {materialDetail && (
              <>
                <PageHeadingWithBackButton
                  headingCaption={`Legislatívny proces ${type}/${year}/${index}`}
                  heading="Zoznam odoslaných notifikácií k legislatívnemu procesu"
                  withBackLink
                />
                <NotifikaciaHistoriaList materialDetail={materialDetail} />
              </>
            )}
          </>
        </PageLoader>
      </SecuredPage>
    </Layout>
  );
};

export default NotifikaciaHistoriaListPage;
